(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  // Global cart notification function
  window.showCartNotification = function(message, type = 'success') {
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === 'success' ? '#4CAF50' : '#f44336'};
      color: white;
      padding: 12px 20px;
      border-radius: 4px;
      z-index: 10000;
      transform: translateX(100%);
      transition: transform 0.3s ease;
      font-family: 'Crete Round', serif;
      font-size: 14px;
      box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    `;
    notification.textContent = message;
    document.body.appendChild(notification);
    
    setTimeout(() => {
      notification.style.transform = 'translateX(0)';
    }, 100);
    
    setTimeout(() => {
      notification.style.transform = 'translateX(100%)';
      setTimeout(() => notification.remove(), 300);
    }, 3000);
  };

  // Mobile menu functionality - Fixed
  document.addEventListener('DOMContentLoaded', function() {
    const menuToggle = document.querySelector('.header__icon--summary');
    const menuDrawer = document.getElementById('Details-menu-drawer-container');
    const hamburgerIcon = document.querySelector('.hamburger-icon');
    const closeIcon = document.querySelector('.close-icon');
    const drawerCloseButton = document.querySelector('.menu-drawer__close-button');
    const body = document.body;
    
    function openMenu() {
      menuDrawer.setAttribute('open', '');
      hamburgerIcon.style.display = 'none';
      closeIcon.style.display = 'block';
      body.style.overflow = 'hidden'; // Prevent background scroll
    }
    
    function closeMenu() {
      menuDrawer.removeAttribute('open');
      hamburgerIcon.style.display = 'block';
      closeIcon.style.display = 'none';
      body.style.overflow = ''; // Restore scroll
    }
    
    function toggleMenu(e) {
      e.preventDefault();
      e.stopPropagation();
      
      if (menuDrawer.hasAttribute('open')) {
        closeMenu();
      } else {
        openMenu();
      }
    }
    
    // Add click event to hamburger button
    if (menuToggle && menuDrawer) {
      menuToggle.addEventListener('click', toggleMenu);
      menuToggle.addEventListener('touchstart', toggleMenu, { passive: false });
    }
    
    // Add click event to close button inside drawer
    if (drawerCloseButton) {
      drawerCloseButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeMenu();
      });
    }
    
    // Close menu when clicking on menu items
    const menuItems = document.querySelectorAll('.menu-drawer__menu-item');
    menuItems.forEach(item => {
      item.addEventListener('click', closeMenu);
    });
    
    // Close menu when clicking outside
    document.addEventListener('click', function(e) {
      if (menuDrawer.hasAttribute('open') && !menuDrawer.contains(e.target) && !menuToggle.contains(e.target)) {
        closeMenu();
      }
    });
    
    // Handle escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && menuDrawer.hasAttribute('open')) {
        closeMenu();
      }
    });
    
    // Enhanced add to cart functionality for all forms
    document.addEventListener('submit', function(e) {
      if (e.target.matches('form[action*="/cart/add"]') || e.target.closest('product-form')) {
        const form = e.target.matches('form') ? e.target : e.target.closest('form');
        if (!form) return;
        
        // Let the original form submission handle the cart notification
        // This is just to ensure our global notification is available
        setTimeout(() => {
          if (window.showCartNotification && !document.querySelector('cart-notification.active')) {
            // Only show if no other cart notification is active
            const submitBtn = form.querySelector('[type="submit"]');
            if (submitBtn && !submitBtn.hasAttribute('aria-disabled')) {
              // Form submission was successful
              window.showCartNotification('✓ Product added to cart!', 'success');
            }
          }
        }, 500);
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
